<template>
  <div class="flex flex-col items-center justify-center" :style="{ height: maxHeight + 'px' }">
    <form @submit.prevent="isLogin ? login() : register()" class="flex flex-col items-center w-[300px] gap-8">
      <h2 class="text-2xl font-bold text-left w-full">{{ isLogin ? "Se connecter" : "S'inscrire" }}</h2>
      
      <!-- Champ Email -->
      <input v-model="email" type="email" placeholder="Email" required class="w-full basicInput" />
      
      <div class="w-full">
        <!-- Champ Mot de passe -->
        <div class="relative w-full">
          <input
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            placeholder="Mot de passe"
            required
            class="w-full basicInput pr-10"
          />
          <span
            @click="showPassword = !showPassword"
            class="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
          >
            <i :class="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
          </span>
        </div>
        
        <!-- Lien "Mot de passe oublié" visible seulement en mode connexion -->
        <p v-if="isLogin" class="w-full text-right mt-1">
          <a href="#" class="text-sm text-[#E8535D] hover:underline cursor-pointer" @click.prevent="forgotPassword">
            Mot de passe oublié ?
          </a>
        </p>
      </div>
      
      <!-- Message d'erreur -->
      <p v-if="errorMessage" class="text-red-500 text-sm text-left w-full">{{ errorMessage }}</p>
      
      <!-- Message de vérification d'email -->
      <p v-if="$route.query.verify" class="text-red-500 text-sm text-left w-full">
        Merci de valider votre adresse email avant de vous connecter.
      </p>
      
      <!-- Bouton de soumission -->
      <button type="submit" class="w-full flex items-center justify-center callToAction">
        {{ isLogin ? "Connexion" : "Inscription" }}
      </button>
    </form>
    
    <!-- Lien pour basculer entre Login et Register -->
    <p class="mt-2">
      <a href="#" @click.prevent="toggleAuthMode" class="text-[#E8535D] hover:underline cursor-pointer">
        {{ isLogin ? "Pas encore de compte ?" : "Déjà un compte" }}
      </a>
    </p>
  </div>
</template>

<script>
import { auth, db } from "@/firebase";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, sendEmailVerification } from "firebase/auth";
import { doc, setDoc, serverTimestamp } from 'firebase/firestore'
import { clearPlanFeaturesCache } from "@/plans"; // <-- Ajoute cet import
import { addNewUser } from "@/services/userService";

export default {
  data() {
    return {
      email: "",
      password: "",
      isLogin: true, // Définit si on est en mode "Login" ou "Register"
      errorMessage: "", // Message d'erreur à afficher
      showPassword: false, // <--- ici
    };
  },
  computed: {
    maxHeight() {
      return window.innerHeight - 32; // Ajuste la hauteur maximale en fonction de la taille de la fenêtre
    },
  },
  methods: {
    async login() {
      try {
        await signInWithEmailAndPassword(auth, this.email, this.password);
        clearPlanFeaturesCache(); // <-- Ajoute ici
        const redirect = this.$route.query.redirect || '/planning';
        this.$router.replace(redirect);
        console.log("Connexion réussie");
      } catch (error) {

        this.handleError(error);
      }
    },
    async register() {
      try {
        const userCredential = await createUserWithEmailAndPassword(auth, this.email, this.password);
        const user = userCredential.user;

        // Ajoute l'utilisateur via le service
        await addNewUser(user);

        clearPlanFeaturesCache(); // <-- Ajoute ici

        await sendEmailVerification(userCredential.user, {
          url: "https://www.nailit-planning.com/login" // ou la page de ton choix
        });
        this.errorMessage = "";
        alert("Un email de vérification a été envoyé. Merci de valider votre adresse avant de vous connecter.");
        // Optionnel : déconnecte l'utilisateur après inscription
        await auth.signOut();
        clearPlanFeaturesCache(); // <-- Ajoute ici aussi après déconnexion
      } catch (error) {
        this.handleError(error);
      }
    },
    toggleAuthMode() {
      this.isLogin = !this.isLogin; // Bascule entre Login et Register
      this.errorMessage = ""; // Réinitialise le message d'erreur
    },
    handleError(error) {
      // Gestion des erreurs Firebase
      console.log(error.code);
      switch (error.code) {
        case "auth/user-not-found":
          this.errorMessage = "Aucun compte trouvé avec cet email.";
          break;
        case "auth/invalid-credential":
          this.errorMessage = "L'email ou le mot de passe est incorrect.";
          break;
        case "auth/email-already-in-use":
          this.errorMessage = "Cet email est déjà utilisé.";
          break;
        case "auth/weak-password":
          this.errorMessage = "Le mot de passe doit faire au moins 6 caractères.";
          break;
        default:
          this.errorMessage = "Une erreur est survenue. Veuillez réessayer.";
      }
    },
    async forgotPassword() {
      const email = this.email;
      if (!email) {
        this.errorMessage = "Veuillez entrer votre adresse email.";
        return;
      }
      try {
        await sendPasswordResetEmail(auth, email, {
          // Optionnel : personnalise l'URL de redirection après le reset
          url: "https://www.nailit-planning.com/login"
        });
        this.errorMessage = "";
        alert(`Un email de réinitialisation a été envoyé à ${email}.`);
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>